import * as d3 from 'd3'

export default {
  methods: {
    
    GanttChart(selection, _item) {

      let ganttCanvas = selection
      .append('g')
      .attr('transform', `translate(${this.header.width}, ${-10})`)

      let data = this.dataSet.filter(f=> f.PHASE == _item.PHASE && f.GROUP == _item.GROUP && f.ITEM == _item.ITEM)
      
      data.forEach(d=> {

        let workOrder = ganttCanvas
        .append('g')
        .attr('id',`IDX_${d.IDX}`)
        .attr('transform', `translate(0, 0)`)
        .call(this.open_WorkOrder, d, _item)

        workOrder
        .append('rect')
        .attr('x', d.STATUS == 'Planned' ? -63 : this.timeline.scale(d.sDate)).attr('y', 0)
        .attr('width', this.timeline.scale(d.eDate) - this.timeline.scale(d.sDate))
        .attr('height', 12.5).attr('fill-opacity', .5)
        .attr('stroke-width', .5).attr('stroke', d.stroke)
        .attr('fill', ()=> {
          let color = d.color
          if(d.LAUNCH && d.LAUNCH<this.timeline.cutoff) color = '#E0E0DF'
          return color
        })

        workOrder
        .append('text')
        .attr('x', d.STATUS == 'Planned' ? -60 : this.timeline.scale(d.sDate)+3).attr('y', 9)
        .attr('font-size', 8.5).attr('fill', d.thisWeek == '' ? '#757575' : '#000')
        .text('R' + d.REV)

        if(d.thisWeek == 'Y' || d.planned == 'Y') {
          workOrder
          .append('image')
          .attr('xlink:href', this.HOST + `/WorkOrder/avatar/${d.INCHARGE ? d.INCHARGE : 'default'}.png`)
          .attr('x', d.STATUS == 'Planned' ? -26 : this.timeline.scale(d.eDate)-21).attr('y', -5).attr('width', 23)
        }
      })
      

    },

  }
}
